import { Box   } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';
import NextImage from 'next/image';
import React from 'react';

import type { Image } from '@/modules/shared/types';

type ImageProps = BoxProps & {
	children?:  React.ReactNode
	image:      Image
	loading?:   'eager' | 'lazy'
	objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
	priority?:  boolean
	quality?:   number
	sizes?:     string
};

export const NextImageWrapper = ({
	aspectRatio = 'landscape',
	children,
	image,
	loading = 'lazy',
	objectFit = 'cover',
	priority = false,
	quality = 75,
	sizes,
	...rest
}: ImageProps) => {
	return (
		<Box
			aspectRatio={aspectRatio}
			borderRadius="lg"
			overflow="hidden"
			position="relative"
			{...rest}
		>
			<NextImage
				alt={image.alt}
				fill
				loading={loading}
				priority={priority}
				quality={quality}
				sizes={sizes}
				src={image.src}
				style={{ objectFit }}
			/>
			{children}
		</Box>
	);
};
